import { Stack } from '@mui/material';
import InvestmentCheckLogin from './InvestmentCheckLogin';
import InvestmentCounseling from './InvestmentCounseling';
import { PdpInfoDTO } from '@/types/models';
interface InvestmentActionsProps {
  data: PdpInfoDTO;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const InvestmentActions = ({
  data
}: InvestmentActionsProps) => {
  return <Stack sx={{
    position: {
      xs: 'fixed',
      md: 'unset'
    },
    zIndex: 1000,
    right: 0,
    bottom: 56,
    width: '100%',
    bgcolor: {
      xs: 'background.bg',
      md: 'unset'
    },
    p: {
      xs: 'var(--spacing_m)',
      md: 'unset'
    },
    mb: {
      xs: 'var(--spacing_s)',
      md: 'unset'
    },
    boxShadow: {
      xs: '0px 0px 2px 0px rgba(0, 26, 63, 0.10), 0px -7px 15px 0px rgba(0, 26, 63, 0.15)',
      md: 'unset'
    }
  }} data-sentry-element="Stack" data-sentry-component="InvestmentActions" data-sentry-source-file="InvestmentActions.tsx">
      <Stack sx={{
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      gap: 'var(--spacing_m)'
    }} data-sentry-element="Stack" data-sentry-source-file="InvestmentActions.tsx">
        <InvestmentCheckLogin data={data} data-sentry-element="InvestmentCheckLogin" data-sentry-source-file="InvestmentActions.tsx" />
        <InvestmentCounseling data-sentry-element="InvestmentCounseling" data-sentry-source-file="InvestmentActions.tsx" />
      </Stack>
    </Stack>;
};
export default InvestmentActions;